/**
 * Import CSS
 */
import './imageSlider.css';

/**
 * Create an image slider with the given images and videos
 * @param {*} configData
 * @return {Node}
 * @constructor
 */
export default function ImageSlider(configData) {
  let flexsliderBox = document.createElement('div');
  flexsliderBox.className = 'flexslider';

  let flexsliderList = document.createElement('ul');
  flexsliderList.className = 'slides';

  for (let i = 0; i < configData.length; i++) {
    let listPointContent;
    let listPoint = document.createElement('li');

    switch (configData[i].type) {
      case 'image':
        listPointContent = document.createElement('img');
        listPointContent.src = configData[i].url;
        break;
      case 'video':
        listPointContent = document.createElement('iframe');
        listPointContent.width = '100%';
        listPointContent.src = configData[i].url + '?rel=0&controls=0&showinfo=0';
        listPointContent.setAttribute('frameborder', '0');
        listPointContent.setAttribute('allow', 'encrypted-media');
        break;
      default:
    }

    listPoint.appendChild(listPointContent);
    flexsliderList.appendChild(listPoint);
  }

  flexsliderBox.appendChild(flexsliderList);

  $(document).ready(function() {
    $('.flexslider').flexslider();
  });

  return flexsliderBox;
}
